var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "referrer_box" },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c("span", { staticClass: "page-title" }, [_vm._v("FAQ's")])
          ]),
          _vm._v(" "),
          _c("el-col", { staticClass: "back-col", attrs: { span: 12 } }, [
            _c(
              "span",
              {
                staticClass: "btn-back",
                on: {
                  click: function($event) {
                    return _vm.goBack()
                  }
                }
              },
              [_c("i", { staticClass: "el-icon-arrow-left" }), _vm._v("BACK")]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-collapse",
                {
                  model: {
                    value: _vm.activeNames,
                    callback: function($$v) {
                      _vm.activeNames = $$v
                    },
                    expression: "activeNames"
                  }
                },
                _vm._l(_vm.faqs, function(faq) {
                  return _c("el-collapse-item", {
                    key: faq.id,
                    attrs: { name: faq.position },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function() {
                            return [
                              _c(
                                "span",
                                { staticClass: "accordion-question" },
                                [_vm._v(_vm._s(faq.question))]
                              )
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("span", { staticClass: "accordion-answer" }, [
                                _vm._v(_vm._s(faq.answer))
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00a59658", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00a59658","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/faq/viewFaq.vue
// module id = null
// module chunks = 